import customFormatters from '@/filters/customFormatters'

export default {
  name: 'CenterInfo',
  mixins: [customFormatters],
  components: {},
  props: {
    center: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    year () {
      return new Date().getFullYear()
    },
    yearBudget () {
      const budgetData = this.center.shop_budgets.find(b => b.year === this.year)
      return (budgetData && Number(budgetData.budget)) || 0
    },
    remainingBudget () {
      return this.yearBudget - this.center.real_budget
    },
    background () {
      return this.remainingBudget > 0
        ? 'var(--colorPrimaryVeryTransparent)'
        : 'var(--colorFeedErrorVeryTransparent)'
    }
  },
  methods: {
    updateBudget () {
      this.$emit('updateBudget')
    }
  }
}
